import "core-js/modules/es.array.iterator.js";
import React from 'react';
import clsx from 'clsx';
import { Collapse } from '@isyc-react/design/bootstrap';
import '@isyc-react/design/main';
import "./table.style.scss";
export const ListMobile = props => {
  const {
    instance
  } = props;
  const {
    page: rows,
    prepareRow
  } = instance;
  return /*#__PURE__*/React.createElement(React.Fragment, null, rows.map((row, i) => /*#__PURE__*/React.createElement(React.Fragment, null, prepareRow(row), /*#__PURE__*/React.createElement(RowRender, {
    key: i,
    row: row
  }))));
};
const RowRender = props => {
  const {
    row
  } = props;
  const [collapse, setCollapse] = React.useState(false);
  const cellsRender = row.cells.filter(cell => cell.column.isMobile);
  const cellsList = row.cells.filter(cell => !cell.column.isMobile);
  React.useEffect(() => {
    setCollapse(false);
  }, [row.cells]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "list-group d-flex justify-content-center mb-2"
  }, /*#__PURE__*/React.createElement("li", {
    className: "list-group-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between"
  }, cellsList.length > 0 && /*#__PURE__*/React.createElement("span", {
    onClick: () => setCollapse(!collapse),
    className: clsx('mdi text-primary me-3', {
      'mdi-plus': !collapse,
      'mdi-minus': collapse
    })
  }), cellsRender.length > 0 ? cellsRender.map((cell, i) => /*#__PURE__*/React.createElement("span", {
    key: i
  }, cell.render('Cell'))) : cellsList[0].render('Cell')), cellsList.length > 0 && /*#__PURE__*/React.createElement(Collapse, {
    in: collapse
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("ul", {
    className: "ps-4"
  }, cellsList.map((cell, i) => {
    if (cellsRender.length === 0 && i === 0) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return /*#__PURE__*/React.createElement("li", {
      className: "mb-2",
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "me-2"
    }, cell.render('Header'), ":"), cell.render('Cell')));
  })))))));
};